import a_ok from 'assets/img/stock/A-OK.png';
import Bubendorff from 'assets/img/stock/Bubendorff.png';
import Eckermann from 'assets/img/stock/Eckermann.png';
import Gaposa from 'assets/img/stock/Gaposa.png';
import Somfy from 'assets/img/stock/Somfy.png';
import Becker from 'assets/img/stock/becker.jpg';

//type moteur
import Filaire from 'assets/img/stock/Filaire.png';
import IO from 'assets/img/stock/IO.png';
import RTS from 'assets/img/stock/RTS.png';
import Radio from 'assets/img/stock/Radio.png';
import Solaire from 'assets/img/stock/Solaire.png';

import sans_btn from 'assets/img/stock/sans_tele.png';
import avec_btn from 'assets/img/stock/telecommandes.png';

import sans_telecommande from 'assets/img/sans-telecommande.png';
import avec_telecommande from 'assets/img/telecommande.png';


import ManivelleDroite from 'assets/img/manivelle-droite.png';
import ManivelleGauche from 'assets/img/manivelle-gauche.png';

import StoreDemiCoffre from 'assets/img/store-demi-coffre.png';

import StoreCoffre from 'assets/img/store-demi-coffre.png';
import StoreMonobloc from 'assets/img/store-monobloc.png';
import StoreBanneToile from 'assets/img/store-banne-toile.png';
import StoreBrasDroits from 'assets/img/store-bras-droite.png';
import StoreDecenteVertical from 'assets/img/store-descente-verticale.png';
import StoreDoublePente from 'assets/img/store-double-pente.png';

import ManoeuvreElectrique from 'assets/img/manoeuvre-electrique.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import gauche from 'assets/img/stock/gauche.png';
import droite from 'assets/img/stock/droite.png';
import StoreCapteurVent from 'assets/img/store-capteur-vent.png';
import StoreSansCapteurVent from 'assets/img/store-sans-capteur-vent.png';
const formInputsTypes = {
	RADIO_INPUT: 'RADIO_INPUT',
	SELECT_INPUT: 'SELECT_INPUT',
	INPUT_TEXT: 'INPUT_TEXT',
	INPUT_NUMBER: 'numeric',
	SELECTABLE_IMAGE: 'SELECTABLE_IMAGE',
	CHECKBOX_INPUT: 'CHECKBOX_INPUT',
};

export default formInputsTypes;

export const shortCode = {
	'VR-TR-AXE-MN': 'axe manuel Volet Roulant tradi',
};
export const axeData = [
	{
		id: 4505,
		value: 'Tube ZF54',
		label: 'Tube ZF54',
		lst_price: 15.5,
		diametre: 54,
		description: '- Axe d’enroulement en tube acier ZF54.',
	},
	{
		id: 8882,
		value: 'TUBE ZF64',
		label: 'TUBE ZF64',
		lst_price: 8.85,
		diametre: 64,
		description: '- Axe d’enroulement renforcé en tube acier ZF64.',
	},
	{
		id: 11306,
		value: 'Octo 40',
		label: 'Axe octo 40',
		lst_price: 8.85,
		diametre: 45,
		description: '- Axe octogonal de diamètre 40 mm.',
	},
	{
		id: 11328,
		value: 'Octo 60',
		label: 'Axe octo 60',
		lst_price: 8.85,
		diametre: 54,
		description: '- Axe octogonal de diamètre 60 mm.',
	},
	{
		id: 11330,
		value: 'Octo 80',
		label: 'Axe octo 80',
		lst_price: 8.85,
		diametre: 80,
		description: '- Axe octogonal renforcé de diamètre 80 mm.',
	},

]

export const createAxe = (nextStepData) => ({
	id: 'VR-TR-AXE-API',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Sélectionner un axe',
	name: 'axe',
	nextStepData,
	nextStep: false,
	options: axeData
});

export const TypeMesureLarg = (nextStepData) => ({
	id: 'VR-TR-AXE-TMOW',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'typeMesureLargeur',
	className: 'col-6',
	label: 'Mesure selon largeur',
	nextStepData: nextStepData,
	nextStep: false,
	options: [
		{
			id: 'VR-TR-AXE-TMOW-FN',
			label: 'FINI',
			value: 'FINI',
			nextStep: false,
			description: '- Mesure de largeur : FINI',
		},
		{
			id: 'VR-TR-AXE-TMOW-DC',
			label: 'D.C',
			value: 'D.C',
			nextStep: false,
			description: '- Mesure de largeur : D.C',
		},
	],
});

export const TypeMesureHaut = (nextStepData) => ({
	id: 'VR-TR-AXE-TMOW',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'typeMesureLargeur',
	className: 'col-6',
	label: 'Mesure selon largeur',
	nextStepData: nextStepData,
	nextStep: false,
	options: [
		{
			id: 'VR-TR-AXE-TMOW-FN',
			label: 'FINI',
			value: 'FINI',
			nextStep: false,
			description: '- Mesure de hauteur : FINI',
		},
		{
			id: 'VR-TR-AXE-TMOW-DC',
			label: 'D.C',
			value: 'D.C',
			nextStep: false,
			description: '- Mesure de hauteur : D.C',
		},
	],
});

export const Moteur = () => ({
	id: 'Moteur',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sélectionner la marque de moteur',
	name: 'Moteur',
	classGroup: 'SProduit',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'Becker',
			label: '',
			value: 'Becker',
			imageUrl: Becker,
			nextStep: typeMoteurRadioFilaireSolaire(),
		},
		{
			id: 'Somfy',
			label: '',
			value: 'Somfy',
			imageUrl: Somfy,
			nextStep: typeMoteursomfy(),
			// description: '- Moteur tubulaire de la marque Somfy',
		},
		{
			id: 'Bubendorff',
			label: '',
			value: 'Bubendorff',
			imageUrl: Bubendorff,
			nextStep: typeMoteurRadioFilaire(),
		},
		{
			id: 'AOK',
			label: '',
			value: 'A-OK',
			imageUrl: a_ok,
			nextStep: typeMoteurRadioFilaireSolaire(),
		},
		{
			id: 'Eckermann',
			label: '',
			value: 'Eckermann',
			imageUrl: Eckermann,
			nextStep: typeMoteurRadioFilaire(),
		},
		{
			id: 'Gaposa',
			label: '',
			value: 'Gaposa',
			imageUrl: Gaposa,
			nextStep: typeMoteurRadioFilaireSolaire(),
		},
	],
});



export const typeTelecommande = () => ({
	id: 'VR-TC-TYPE',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de télécommande',
	name: 'typeTelecommande',
	className: 'col-6',
	classGroup: 'SProduit',
	nextStepData: false,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const isKit = currentFormValue?.values?.product?.value == "Kit Motorisation";

		const options = [
			{
				id: 'telecommande_portative',
				value: 'Portative',
				label: 'Portative',
				imageUrl: avec_telecommande,
				nextStep: isKit ? isWithAgraffe() : false,
				description:
					"- Télécommande portative permettant une utilisation mobile et flexible.\n\n" +
					"- Accessoires d’adaptation :\n" +
					"  - Roue dentée, Couronne de fixation\n" +
					"  - Embout coussinette anti-vibration\n" +
					"  - Support moteur\n",
			},
			{
				id: 'telecommande_murale',
				value: 'Murale',
				label: 'Murale',
				imageUrl: avec_btn,
				nextStep: isKit ? isWithAgraffe() : false,
				description:
					"- Télécommande murale.\n\n" +
					"- Accessoires d’adaptation :\n" +
					"  - Roue dentée, Couronne de fixation\n" +
					"  - Embout coussinette anti-vibration\n" +
					"  - Support moteur\n",
			},
		]
		fnSuccess(options);
	},
});



export const telecommande = () => ({
	id: 'MD',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Télécommande',
	name: 'telecommande',
	className: 'col-6',
	classGroup: 'SProduit',
	nextStepData: false,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const isKit = currentFormValue?.values?.product?.value == "Kit Motorisation";

		const options = [
			{
				id: 'telecommande_non',
				value: 'Sans télécommande',
				label: '',
				imageUrl: sans_telecommande,
				nextStep: isKit ? isWithAgraffe() : false,
				description:
					"- Accessoires d’adaptation :\n" +
					"  - Roue dentée, Couronne de fixation\n" +
					"  - Embout coussinette anti-vibration\n" +
					"  - Support moteur\n",
			},
			{
				id: 'telecommande_oui',
				value: 'Avec télécommande',
				label: '',
				imageUrl: avec_telecommande,
				nextStep: typeTelecommande(currentFormValue),
			},
		]
		fnSuccess(options);
	},

});
export const attaches = {
	id: 'VR-TR-AXE-W',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'attaches',
	className: 'col-6',
	label: 'Nombre Agraffe Rigide',
	nextStepData: false,
	nextStep: false,
	validation: (value) => {
		return value > 0;
	},
};
export const poussoir = () => ({
	id: 'MD',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Avec / sans bouton poussoir',
	name: 'poussoir',
	className: 'col-6',
	classGroup: 'SProduit',
	nextStepData: false,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const isKit = currentFormValue?.values?.product?.value == "Kit Motorisation";

		const options = [
			{
				id: 'sans_poussoir',
				value: 'Sans bouton poussoir',
				label: '',
				imageUrl: sans_btn,
				nextStep: !!isKit ? isWithAgraffe() : false,
				description:
					"- Accessoires d’adaptation :\n" +
					"  - Roue dentée,Couronne de fixation\n" +

					"  - Embout coussinette anti-vibration \n" +
					"  - Support moteur \n"
			},
			{
				id: 'avec_poussoir',
				value: 'Avec bouton poussoir',
				label: '',
				imageUrl: avec_btn,
				nextStep: !!isKit ? isWithAgraffe() : false,

				description:
					"- Configuration avec bouton poussoir mural filaire.\n\n" +
					"- Accessoires d’adaptation :\n" +
					"  - Roue dentée,Couronne de fixation\n" +
					"  - Embout coussinette anti-vibration \n" +
					"  - Support moteur \n"
			},
		]
		fnSuccess(options);
	},

});

export const puissanceMoteur = (nextStepData = telecommande()) => ({
	id: 'puissance',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sélectionner la puissance du moteur',
	name: 'puissance',
	nextStepData, // ✅ telecommande(...) passé en param
	nextStep: false,
	options: [
		{
			id: '10',
			label: '10 Nm',
			value: '10',
			description: '- Puissance de moteur : Couple 10 Newton-mètre.\n' +
				'- Vitesse moteur : 17 tours/min '
		},
		{
			id: '20',
			label: '20 Nm',
			value: '20',
			description: '- Puissance de moteur : Couple 20 Newton-mètre.\n' +
				'- Vitesse moteur : 17 tours/min '
		},
		{
			id: '30',
			label: '30 Nm',
			value: '30',
			description: '- Puissance de moteur : Couple 30 Newton-mètre.\n' +
				'- Vitesse moteur : 17 tours/min '
		},
		{
			id: '40',
			label: '40 Nm',
			value: '40',
			description: '- Puissance de moteur : Couple 40 Newton-mètre.\n' +
				'- Vitesse moteur : 17 tours/min '
		},
		{
			id: '50',
			label: '50 Nm',
			value: '50',
			description: '- Puissance de moteur : Couple 50 Newton-mètre.\n' +
				'- Vitesse moteur : 17 tours/min '
		},
	],

});

export const typeMoteurRadioFilaire = () => ({
	id: 'VR-TR-AXE-MM-TM',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sélectionner un type de moteur',
	name: 'typeMotor',
	nextStepData: false,
	classGroup: 'SProduit',
	nextStep: false,
	fetchData: (currentFormValue, fnSuccess) => {
		const typeMoteur = currentFormValue?.values?.Moteur?.value;

		const options = [
			{
				id: 'Filaire',
				label: '',
				imageUrl: Filaire,
				value: 'filaire',
				nextStep: puissanceMoteur(poussoir()), // ✅
				description:
					`- Marque de moteur : ${typeMoteur} filaire connecté directement à un interrupteur mural.`,
			},
			{
				id: 'Radio',
				label: '',
				imageUrl: Radio,
				value: 'radio',
				nextStep: puissanceMoteur(telecommande()), // ✅
				description: `- Marque de moteur : ${typeMoteur} radio.`,
			},

		]
		fnSuccess(options)
	},

});

export const typeMoteurRadioFilaireSolaire = () => ({
	id: 'VR-TR-AXE-MM-TM',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sélectionner un type de moteur',
	name: 'typeMotor',
	classGroup: 'SProduit',
	nextStepData: false,
	nextStep: false,
	fetchData: (currentFormValue, fnSuccess) => {
		const typeMoteur = currentFormValue?.values?.Moteur?.value;

		const options = [
			{
				id: 'Filaire',
				label: '',
				imageUrl: Filaire,
				value: 'filaire',
				nextStep: puissanceMoteur(poussoir()), // ✅
				description:
					`- Marque de moteur : ${typeMoteur} filaire connecté directement à un interrupteur mural.`,
			},
			{
				id: 'Radio',
				label: '',
				imageUrl: Radio,
				value: 'radio',
				nextStep: puissanceMoteur(telecommande()), // ✅
				description: `- Marque de moteur : ${typeMoteur} radio.`,
			},
			{
				id: 'Solaire',
				label: '',
				imageUrl: Solaire,
				value: 'solaire',
				nextStep: false,
				description: `- Marque de moteur : ${typeMoteur} solaire avec alimentation autonome par panneau photovoltaïque.`,
			},
		]
		fnSuccess(options)
	},
});

export const typeMoteursomfy = () => ({
	id: 'VR-TR-AXE-MM-TM',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sélectionner un type de moteur',
	name: 'typeMotor',
	classGroup: 'SProduit',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'Radio RTS',
			label: '',
			imageUrl: RTS,
			value: 5,
			nextStep: puissanceMoteur(telecommande()), // ✅
			description: '- Marque de moteur : Somfy RTS .',
		},
		{
			id: 'Radio',
			label: '',
			imageUrl: IO,
			value: 'radio',
			nextStep: puissanceMoteur(telecommande()), // ✅
			description: '- Marque de moteur : Somfy IO pour intégration domotique.',
		},
		{
			id: 'Filaire',
			label: '',
			imageUrl: Filaire,
			value: 'filaire',
			nextStep: puissanceMoteur(poussoir()), // ✅
			description: '- Marque de moteur : Somfy filaire connecté directement à un interrupteur mural.',
		},
		{
			id: 'Solaire',
			label: '',
			imageUrl: Solaire,
			value: 'solaire',
			nextStep: false,
			description:
				'- Marque de moteur : Somfy solaire.',
		},
	],


});
export const cote_manivelle = (nextData) => ({
	id: 'cote_manivelle',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Côté manœuvre',
	name: 'cote_manivelle',
	className: 'col-6',
	nextStepData: nextData,
	nextStep: false,
	options: [
		{
			id: 'Gm',
			label: 'Gauche',
			value: 'gauche',
			imageUrl: ManivelleGauche,
			nextStep: false,
			description: '- Manœuvre manuelle à gauche',
		},
		{
			id: 'DM',
			label: 'Droite',
			value: 'droite',
			imageUrl: ManivelleDroite,
			nextStep: false,
			description: '- Manœuvre manuelle à droite',
		},
	],
});

export const isWithAgraffe = (nextData = attaches, falseNextData = false) => ({
	id: 'isWithAgraffe',
	type: formInputsTypes?.RADIO_INPUT,
	style: { display: 'none' },
	label: 'Avec Agraffe ?',
	name: 'isWithAgraffe',
	className: 'col-6 d-none',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'with-agraffe',
			label: 'Oui',
			value: 'oui',
			checked: true,
			nextStep: nextData,
		},
		{
			id: 'with-agraffe',
			label: 'Non',
			value: 'non',
			checked: false,
			nextStep: falseNextData,

		},
	],
});

export const LameColor = (nextStepData, label) => ({
	id: `VR-TR-VRC-LC-${label.replace(/\s+/g, '_')}`,
	type: formInputsTypes?.RADIO_INPUT,
	name: label,
	classGroup: 'Simulateur_color',
	label,
	defaultValue: 0,
	nextStepData,
	nextStep: false,
	options: [
		{
			id: 6,
			label: 'Blanc RAL 9016',
			color: '#ffffff',
			icon: 'CustomCircle',
			value: 'Blanc RAL 9016',
			isWhite: true,
			description: `- ${label} blanc RAL 9016.`,
		},
		{
			id: 66,
			label: 'Marron foncé RAL 8014',
			color: '#49372a',
			icon: 'CustomCircle',
			value: 'Marron foncé RAL 8014',
			isWhite: false,
			description: `- ${label} marron foncé RAL 8014.`,
		},
		{
			id: 13,
			label: 'Ivoire RAL 1014',
			color: '#E6D2B5',
			icon: 'CustomCircle',
			value: 'Ivoire RAL 1014',
			isWhite: false,
			description: `- ${label} ivoire RAL 1014.`,
		},
		{
			id: 8,
			label: 'Gris métallique RAL 9006',
			color: '#808080',
			icon: 'CustomCircle',
			value: 'Gris métallique RAL 9006',
			isWhite: false,
			description: `- ${label} gris métallique RAL 9006.`,
		},
		{
			id: 60,
			label: 'Gris Clair RAL 7035',
			color: '#C5C7C4',
			icon: 'CustomCircle',
			value: 'Gris Clair RAL 7035',
			description: `- ${label} gris clair RAL 7035.`,
		},
		{
			id: 14,
			label: 'Anthracite RAL 7016',
			color: '#383e42',
			icon: 'CustomCircle',
			value: 'Anthracite RAL 7016',
			isWhite: false,
			description: `- ${label} gris anthracite RAL 7016.`,
		},
		{
			id: 16,
			label: 'Chêne doré 038 / bois de chêne',
			color: '#CD853F',
			icon: 'CustomCircle',
			value: 'Chêne doré 038 / bois de chêne',
			isWhite: false,
			description: `- ${label} chêne doré 038 / bois de chêne.`,
		},
	],
});

export const LameTaille = (nextData) => ({
	id: 'VR-TR-VRC-LT',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'lameTaille',
	className: 'col-12',
	label: 'Type de la lame',
	defaultValue: 0,
	nextStepData: nextData,
	nextStep: false,
	options: [
		{
			id: 128,
			label: 'BP37R',
			value: 37,
			description: '- Lame aluminium BP37R.',
			// priceGroup: 'STANDARD',
		},
		{
			id: 126,
			label: 'BP43R',
			value: 43,
			description: '- Lame aluminium BP43R.',
			// priceGroup: 'STANDARD',
		},
		// {
		// 	id: 130,
		// 	label: 'BP45R',
		// 	value: 130,
		// 	description: '- Lame aluminium BP45R.',
		// 	priceGroup: 'STANDARD',
		// },
		{
			id: 127,
			label: 'BP55R',
			value: 55,
			description: '- Lame aluminium BP55R.',
			// priceGroup: 'BP55',
		},
		// {
		// 	id: 131,
		// 	label: 'BP77R',
		// 	value: 77,
		// 	description: '- Lame aluminium BP77R.',
		// 	// priceGroup: 'STANDARD',
		// },
	],
});

export const TypeStorebanne = (nextData) => ({
	id: 'T_Store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Coffre de Store',
	name: 'TypeStorebanne',
	nextStepData: nextData,
	nextStep: false,
	options: [
		{
			id: 'TSB3',
			label: 'Monobloc (sans coffre)',
			value: 'Monobloc',
			imageUrl: StoreMonobloc,
			nextStep: false,
		},
		{
			id: 'TSB2',
			label: 'Coffre',
			value: 'Coffre',
			imageUrl: StoreCoffre,
			nextStep: false,
		},
		{
			id: 'TSB1',
			label: 'Semi coffre',
			value: 'Semi coffre',
			imageUrl: StoreDemiCoffre,
			nextStep: false,
		},
	],
});

export const manoeuvre = (nextData) => ({
	id: 'manoeuvre_store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Manoeuvre',
	name: 'manoeuvre_store',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'manuel',
			label: 'Manuel',
			value: 'manuel',
			imageUrl: ManoeuvreManuel,

			nextStep: manivelle,
		},
		{
			id: 'electrique',
			label: 'Électrique',
			value: 'électrique',
			imageUrl: ManoeuvreElectrique,

			nextStep: telecommande,
		},
	],
});
